import * as common from 'libs/common';
import dayjs from 'dayjs';
/**
 * <p>문자열 날짜를 받아서 요일 숫자값 리턴</p>
 * @param sDate - 문자열 날짜
 * @return integer (0~6)
 */
export function getDay(sDate:string){
    if(!sDate) return -1;    
    let sVal = String(sDate).replace("-","").replace(":","");
    sVal = common.getLeftString(sVal,8);
    sVal = sVal.substring(0, 4) + "-" + sVal.substring(4, 6)+ "-" + sVal.substring(6, 8);
    
    const objDate = new Date(sVal);
    return objDate.getDay();    
}

/**
 * <p>문자열 날짜를 받아서 요일 한글명 리턴</p>
 * @param sDate - 문자열 날짜
 * @return string (요일 한글명)
 */
export function getDayH(sDate:string){        
    let nDay = getDay(sDate);
    let sDay;

    switch (nDay) {
        case 0:
             sDay = "일";
             break;
        case 1:
             sDay = "월";
             break;
        case 2:
             sDay = "화";
             break;
        case 3:
             sDay = "수";
             break;
        case 4:
             sDay = "목";
             break;
        case 5:
             sDay = "금";
             break;
        case 6:
             sDay = "토";
			break;
			
		default :
			sDay = "";
    }
    
    return sDay;
}


/**
 * <p>PC의 오늘 날짜 리턴</p>
 * @return string (8자리 yyyymmdd)
 */
export function getToday(){
    return dayjs().format('YYYYMMDD');
}

/**
 * <p>PC의 오늘 날짜 리턴</p>
 * @return string (8자리 yyyymmdd)
 */
 export function getTodayFormat(sPattern:string){
    return dayjs().format(sPattern);
}

/**
 * <p>AddMonth</p>
 * @return string (8자리 yyyymmdd)
 */
 export function addMonths(sVal:string, diff:number){
    let tmpDate = sVal.replace(/-/gi, '');
    tmpDate = tmpDate.substring(0, 4) + '-' + tmpDate.substring(4, 6) + '-' + tmpDate.substring(6, 8);

    const date = dayjs(tmpDate);  
    const nextMonth = date.add(diff, 'month');  // ✅ 한 달 추가

    return nextMonth.format('YYYYMMDD');
}

/**
 * <p>getDayDiff</p>
 */
 export function getDayDiff(start:string, end:string){
    const date1 = dayjs(maskDate(start, 'YYYY-MM-DD'));
    const date2 = dayjs(maskDate(end  , 'YYYY-MM-DD'));
    
    const diffInDays = date1.diff(date2, 'day'); // 날짜 차이 계산

    return diffInDays;
}

export function formatDateToYYYYMMDD(date:Date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 0부터 시작하므로 +1
    const day = String(date.getDate()).padStart(2, '0');
  
    return `${year}${month}${day}`;
  }


/**
 * <p>해당월의 마지막 날짜를 숫자로 구하기</p>
 * @param sDate - "20110101"
 * @return integer (1~31, 실패시 -1)
 */
export function fn_LastDateNum(sDate:string){
    let nMonth, nLastDate;

    if(!sDate) return -1;
    
    nMonth = parseInt(sDate.substring(4,6), 10);
    if( nMonth === 1 || nMonth === 3 || nMonth === 5 || nMonth === 7  || nMonth === 8 || nMonth === 10 || nMonth === 12 )
        nLastDate = 31;
    else if( nMonth === 2 )  
    {
        if(fn_IsLeapYear(sDate))
             nLastDate = 29;
        else
             nLastDate = 28;
    } 
    else 
        nLastDate = 30;
        
    return nLastDate;
}

/**
 * <p>윤년여부 확인</p>
 * @param sDate - "20110101"
 * @return boolean (윤년이면 true, 그외 false)
 */
export function fn_IsLeapYear(sDate:string){
    let ret;
    let nY;
    
    if(!sDate) return false;
    
    nY = parseInt(sDate.substring(0,4), 10);

    if ((nY % 4) === 0) 
    {
        if ((nY % 100) !== 0 || (nY % 400) === 0) 
             ret = true;
        else 
             ret = false;
    } 
    else 
        ret = false;
  
    return ret;
}

/*
 * 날짜가 유효한지 검사
 * 예) '20090210'
 */
export function fn_IsValidDate(sVal:string) {
    let tmpDate = sVal.replace(/-/gi, '');
    tmpDate = tmpDate.substring(0, 4) + '-' + tmpDate.substring(4, 6) + '-' + tmpDate.substring(6, 8);

    const validDate = dayjs(tmpDate, 'YYYY-MM-DD', true); 
    return validDate.isValid();
}

/**
 * <p>시간값에 대한 유효성 체크</p>
 * @param sTime - 시간값 (시<21>, 시분<2133>, 시분초<213323>)
 */
export function fn_IsValidTime(sTime:string){
    if(!sTime) return false;    

    let nHour = parseInt(sTime.substring(0, 2));
    let nMin = parseInt(sTime.substring(2, 4));
    let nSec = parseInt(sTime.substring(4, 6));
    
    if (nHour) {
        if (nHour < 0 || nHour > 23) {
             return false;
        }
    }
    if (nMin) {
        if (nMin < 0 || nMin > 59) {
             return false;
        }
    }
    if (nSec) {
        if (nSec < 0 || nSec > 59) {
             return false;
        }
    }
    
    return true;
}

/**
 * <p>날짜형식의 문자열을 받아서 포맷팅된 문자열을 리턴</p>
 */
export function maskDate(sVal:string, sPattern:string){    
    if (!sVal) {
        return '';
	}

    let tmpDate = sVal.replace(/-/gi, '');
    tmpDate = tmpDate.substring(0, 4) + '-' + tmpDate.substring(4, 6) + '-' + tmpDate.substring(6, 8);

    return dayjs(tmpDate).format(sPattern)
    
}

/**
 * <p>날짜형식의 문자열을 받아서 포맷팅된 문자열을 리턴</p>
 */
 export function maskDateDefault(sVal:string){    
    if (!sVal) {
        return '';
	}
	
    return maskDate(sVal, 'YYYYMMDD');
}
